import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import {
  fetchContactEmergenciesApi,
  createContactEmergencyApi,
  updateContactEmergencyApi,
  deleteContactEmergencyApi,
} from '../../services/api';
import { Cargando } from '../../components/Cargando';

export default function ContactosEmergencia() {
  const { token } = useAuth();
  const [rows, setRows] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ contacto: '', telefono: '' });
  const [confirmTarget, setConfirmTarget] = useState(null); // { id, name }
  const [toasts, setToasts] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    try {
      const list = await fetchContactEmergenciesApi({ token });
      setRows(list);
    } catch {

    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        await reload();
      } catch { } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  // Solo letras (soporta unicode) y espacios/apostrofe/guion
  const onlyLetters = (s) => s.replace(/[^\p{L}\s'\-]/gu, '');
  const onlyDigits = (s) => s.replace(/[^0-9]/g, '');
  // Si inicia con '9' => exactamente 9 digitos; caso contrario libre (no vacio)
  const phoneValid = form.telefono.length > 0 && (!form.telefono.startsWith('9') || form.telefono.length === 9);
  const isValid = form.contacto.length > 0 && form.contacto.length <= 49 && phoneValid;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.contacto || !form.telefono) return;
    try {
      if (editingId == null) {
        await createContactEmergencyApi({ nameContact: form.contacto, phone: form.telefono, token });
        pushToast('success', 'Contacto creado correctamente');
      } else {
        await updateContactEmergencyApi({ id: editingId, nameContact: form.contacto, phone: form.telefono, token });
        pushToast('success', 'Contacto actualizado correctamente');
      }
      await reload();
    } finally {
      setShowForm(false);
      setEditingId(null);
      setForm({ contacto: '', telefono: '' });
    }
  };

  const openAdd = () => { setEditingId(null); setForm({ contacto: '', telefono: '' }); setShowForm(true); };
  const openEdit = (r) => {
    setEditingId(r.id);
    setForm({
      contacto: ((r.name ?? r.contacto) || '').toString().toUpperCase(),
      telefono: (r.phone ?? r.telefono) || ''
    });
    setShowForm(true);
  };
  const onDelete = async (id) => {
    try {
      await deleteContactEmergencyApi({ id, token });
      await reload();
      pushToast('success', 'Contacto eliminado correctamente');
    } catch (e) {
      pushToast('danger', e?.message || 'No se pudo eliminar');
    }
  };

  const pushToast = (type, msg) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, type, msg }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), 3500);
  };

  return (
    <div className="container-fluid">
      <div className="mb-2">
        <h2 className="mb-2 text-center">Contactos de Emergencia</h2>
      </div>

      <div className="mb-3 d-flex gap-2 justify-content-end">
        <button className="btn btn-primary" onClick={openAdd}>
          <i className="bi bi-plus-lg" /></button>
      </div>

      {/* Toasts */}
      <div className="gp-toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast align-items-center text-bg-${t.type} show`} role="alert" aria-live="assertive" aria-atomic="true">
            <div className="d-flex">
              <div className="toast-body">{t.msg}</div>
              <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))} aria-label="Close"></button>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th style={{ width: 140 }}>Acciones</th>
                <th>Contacto</th>
                <th>Telefono</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={12} className="text-center text-muted py-4"><Cargando /></td>
                </tr>
              )}

              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={3} className="text-center text-muted py-4">Sin registros</td>
                </tr>
              )}
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>
                    <div className="btn-group btn-group-sm">
                      <button className="btn btn-outline-primary" title="Editar" onClick={() => openEdit(r)}><i className="bi bi-pencil" /></button>
                      <button className="btn btn-outline-danger" title="Eliminar" onClick={() => setConfirmTarget({ id: r.id, name: r.name ?? r.contacto })}><i className="bi bi-trash" /></button>
                    </div>
                  </td>
                  <td>{r.name ?? r.contacto}</td>
                  <td>{r.phone ?? r.telefono}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className={`modal fade ${showForm ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={showForm}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={onSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{editingId == null ? 'Agregar contacto' : 'Editar contacto'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowForm(false)} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Nombre</label>
                  <input
                    className="form-control"
                    value={form.contacto}
                    maxLength={49}
                    onChange={(e) => setForm({ ...form, contacto: onlyLetters(e.target.value).slice(0, 49).toUpperCase() })}
                    required
                  />
                  <div className="form-text">Maximo 49 caracteres.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Telefono</label>
                  <input
                    className="form-control"
                    value={form.telefono}
                    onChange={(e) => {
                      let v = onlyDigits(e.target.value);
                      if (v.startsWith('9')) v = v.slice(0, 9);
                      setForm({ ...form, telefono: v });
                    }}
                    placeholder="Si inicia con 9: 9 digitos; caso contrario libre"
                    title="Si inicia con 9: 9 digitos; caso contrario libre"
                    required
                  />
                  <div className="form-text">Si inicia con 9 debe tener exactamente 9 digitos; caso contrario, longitud libre.</div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={!isValid}>Guardar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showForm && <div className="modal-backdrop fade show" onClick={() => setShowForm(false)} />}

      {/* Confirmacion de eliminacion */}
      <div className={`modal fade ${confirmTarget ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={!!confirmTarget}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmacion</h5>
              <button type="button" className="btn-close" onClick={() => setConfirmTarget(null)} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              Esta seguro de eliminar el contacto de emergencia{confirmTarget?.name ? ` "${confirmTarget.name}"` : ''}?
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setConfirmTarget(null)}>Cancelar</button>
              <button type="button" className="btn btn-danger" onClick={async () => { const id = confirmTarget.id; setConfirmTarget(null); await onDelete(id); }}>Eliminar</button>
            </div>
          </div>
        </div>
      </div>
      {confirmTarget && <div className="modal-backdrop fade show" onClick={() => setConfirmTarget(null)} />}
    </div>
  );
}

